import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routesConfig } from '../routes/routesConfig';

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Find the matching route
    const currentRoute = routesConfig.find(route => route.path === location.pathname);
    
    let pageTitle = 'KnI Wealth';
    
    if (currentRoute && currentRoute.label) {
      pageTitle = `${currentRoute.label} - KnI Wealth`;
    } else if (location.pathname === '/') {
      pageTitle = 'Order Book - KnI Wealth';
    } else if (location.pathname === '/login') {
      pageTitle = 'Login - KnI Wealth';
    } else if (location.pathname === '/un-authorized') {
      pageTitle = 'Unauthorized - KnI Wealth';
    } else if (location.pathname === '/select-broker') {
      pageTitle = 'Connect broker - KnI Wealth';
    } else {
      // For 404 or any unmatched route
      pageTitle = 'Not Found - KnI Wealth';
    }
    
    document.title = pageTitle;
  }, [location.pathname]);
};

export default usePageTitle;

